import React from "react";
import { FieldValidationError } from "../services/server/ServerValidationError";

export const ValidationAlertContext = React.createContext<(serverValidationError: { errors: FieldValidationError[] }) => void>(() => {});

export function useValidationAlert() {
	const setValidationMessage = React.useContext(ValidationAlertContext);
	return setValidationMessage;
}
